import { Link, useLocation } from 'react-router'
import { Home, Search, FileText, User, Wrench } from 'lucide-react'

const NAV_ITEMS = [
  { href: '/', label: 'Accueil', icon: Home },
  { href: '/services', label: 'Services', icon: Wrench },
  { href: '/recherche', label: 'Recherche', icon: Search },
  { href: '/devis-gratuit', label: 'Devis', icon: FileText },
  { href: '/login', label: 'Compte', icon: User },
]

export function MobileBottomNav() {
  const location = useLocation()

  // CRO mobile_ux_3: hide the bottom nav inside the /demande-devis funnel.
  // Each tab is a 1-tap exit out of a fragile multi-step conversion flow.
  // The funnel routes are noindex, so suppressing this SSR-rendered nav has
  // zero SEO impact and matches behavior on every step of the funnel.
  if (location.pathname.startsWith('/demande-devis')) return null

  function isActive(href: string) {
    if (href === '/') return location.pathname === '/'
    return location.pathname.startsWith(href)
  }

  return (
    <nav aria-label="Navigation principale mobile" className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-white/95 backdrop-blur-lg safe-area-bottom lg:hidden">
      <div className="flex items-center justify-around px-2">
        {NAV_ITEMS.map((item) => {
          const active = isActive(item.href)
          const Icon = item.icon
          return (
            <Link
              key={item.href}
              to={item.href}
              aria-label={item.label}
              aria-current={active ? 'page' : undefined}
              className={`flex flex-col items-center justify-center gap-0.5 rounded-xl px-3 py-2.5 min-w-[56px] min-h-[48px] text-[11px] font-medium transition-all active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 ${
                active ? 'text-primary' : 'text-slate-400'
              }`}
            >
              <Icon className={`h-5 w-5 transition-transform ${active ? 'text-primary scale-110' : ''}`} strokeWidth={active ? 2.5 : 1.8} />
              {item.label}
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
